
'use client';

import { initializeAppInsights } from '@/lib/appInsights';
import { useEffect } from 'react';

interface AppInsightsProviderProps {
  children: React.ReactNode;
}

export default function AppInsightsProvider({ children }: AppInsightsProviderProps) {
  useEffect(() => {
    initializeAppInsights();
  }, []);

  return <>{children}</>;
}